App.controller('HealthPzuwVariantCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', 'packageService', 'branchService', '$stateParams', 'dataUser', 'healthInsuranceService', 'moment', '$rootScope', '$timeout', function ($scope, $sce, $state, $http, $mdDialog, Config, packageService, branchService, $stateParams, dataUser, healthInsuranceService, moment, $rootScope, $timeout) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurancePzuw_variant';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Warianty opieki medycznej';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    setTimeout(function () {
        window.location.href = "/";
    }, 1);
}]);
